import { ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  SzIcCircleComponent,
  SzIconButtonComponent,
  SzIconComponent,
  SzRowCardComponent,
  SzRowCardVariant,
  SzScoreChipComponent,
  SzTypePillComponent
} from '@ui';
import { DrillViewModel } from '../../application/models/drill.view-model';

@Component({
  selector: 'lib-drill-list-item',
  templateUrl: './drill-list-item.component.html',
  styleUrls: ['./drill-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    TranslateModule,
    SzRowCardComponent,
    SzTypePillComponent,
    SzScoreChipComponent,
    SzIcCircleComponent,
    SzIconComponent,
    SzIconButtonComponent
  ]
})
export class DrillListItemComponent {
  readonly drill: InputSignal<DrillViewModel> = input.required<DrillViewModel>();
  readonly variant: InputSignal<SzRowCardVariant> = input<SzRowCardVariant>('flat');
  readonly favoriteToggle: OutputEmitterRef<void> = output<void>();
  readonly select: OutputEmitterRef<void> = output<void>();

  onFavoriteClick(event: MouseEvent): void {
    event.stopPropagation();
    this.favoriteToggle.emit();
  }

  onSelect(): void {
    this.select.emit();
  }
}
